/* <pdp-tabs>: accessible tabs (click + arrow keys). */
if (!customElements.get('pdp-tabs')) {
  class PdpTabs extends HTMLElement {
    connectedCallback() {
      this.ac = new AbortController();
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.tabs.forEach((t, i) => {
        t.addEventListener('click', () => this.activate(i), { signal: this.ac.signal });
        t.addEventListener('keydown', (e) => {
          const n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? this.tabs.length - 1 : null;
          if (n === null) return; e.preventDefault();
          const k = (n + this.tabs.length) % this.tabs.length; this.activate(k); this.tabs[k].focus();
        }, { signal: this.ac.signal });
      });
    }
    disconnectedCallback() { this.ac.abort(); }
    activate(i) {
      this.tabs.forEach((t, k) => { const on = k === i; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; });
      this.panels.forEach((p, k) => { p.hidden = k !== i; const v = p.querySelector('video'); if (v && k !== i) v.pause(); });
    }
  }
  customElements.define('pdp-tabs', PdpTabs);
}
